import { lazyLoadOnRender, loadModule } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { MobileUserSettingsNavProps } from './MobileUserSettingsNav';
import type { UserSettingsNavProps } from './UserSettingsNav';

const loader = () => import(/* webpackChunkName: "4-feat-settings-nav" */ './UserSettingsNav');

const mobileLoader = () => import(/* webpackChunkName: "4-feat-settings-nav-mobile" */ './MobileUserSettingsNav');

export const preloadUserSettingsNav: () => void = () => {
  loadModule(loader);
};

export const LoadableUserSettingsNav: ComponentType<UserSettingsNavProps> = lazyLoadOnRender<UserSettingsNavProps>({
  loader,
});

export const LoadableMobileUserSettingsNav: ComponentType<MobileUserSettingsNavProps> =
  lazyLoadOnRender<MobileUserSettingsNavProps>({ loader: mobileLoader });
